// src/socket.js
import { io } from 'socket.io-client';
import API_BASE_URL from './config/api';

export const socket = io(API_BASE_URL, {
  autoConnect: false, // Prevents automatic connection on initialization
});

export default socket;
